import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Prism from "vue-prism-component";
import _color from "@/assets/utils/color.js";
export default {
  name: "vx-card",
  props: {
    title: String,
    subtitle: String,
    actionButtons: {
      type: Boolean,
      default: false
    },
    actionButtonsColor: {
      type: String,
      default: "success"
    },
    codeToggler: {
      type: Boolean,
      default: false
    },
    noShadow: {
      default: false,
      type: Boolean
    },
    noRadius: {
      default: false,
      type: Boolean
    },
    cardBorder: {
      default: false,
      type: Boolean
    },
    codeLanguage: {
      default: "markup",
      type: String
    },
    collapseAction: {
      default: false,
      type: Boolean
    },
    refreshContentAction: {
      default: false,
      type: Boolean
    },
    removeCardAction: {
      default: false,
      type: Boolean
    },
    headerBackground: {
      default: "",
      type: String
    },
    // bodyBackground: {
    //   default: '',
    //   type: String
    // },
    // headerbackground: {
    //   default: '',
    //   type: String
    // },
    cardBackground: {
      default: "",
      type: String
    },
    contentColor: {
      default: "",
      type: String
    },
    titleColor: {
      default: "",
      type: String
    },
    subtitleColor: {
      default: "#b8c2cc",
      type: String
    }
  },
  data: function data() {
    return {
      isContentCollapsed: false,
      showCode: false,
      maxHeight: null,
      cardMaxHeight: null,
      codeContainerMaxHeight: "0px",
      tempHidden: false
    };
  },
  computed: {
    hasAction: function hasAction() {
      return this.$slots.actions || this.actionButtons || this.collapseAction || this.refreshContentAction || this.removeCardAction || this.codeToggler;
    },
    hasHeader: function hasHeader() {
      return this.hasAction || this.title || this.subtitle;
    },
    StyleItems: function StyleItems() {
      return {
        maxHeight: this.maxHeight
      };
    },
    cardStyles: function cardStyles() {
      var obj = {
        maxHeight: this.cardMaxHeight
      };
      if (!_color.isColor(this.cardBackground)) obj.background = _color.getColor(this.cardBackground);
      if (!_color.isColor(this.contentColor)) obj.color = _color.getColor(this.contentColor);
      return obj;
    },
    codeContainerStyles: function codeContainerStyles() {
      return {
        maxHeight: this.codeContainerMaxHeight
      };
    },
    cardClasses: function cardClasses() {
      var str = ""; // Add bg class

      if (_color.isColor(this.cardBackground)) {
        str += " bg-".concat(this.cardBackground);
      } // add content color


      if (_color.isColor(this.contentColor)) {
        str += " text-".concat(this.contentColor);
      }

      return str.trim();
    },
    titleStyles: function titleStyles() {
      return {
        color: _color.getColor(this.titleColor)
      };
    },
    titleClasses: function titleClasses() {
      var str = ""; // add content color

      if (_color.isColor(this.titleColor)) {
        str += " text-".concat(this.titleColor);
      }

      return str.trim();
    },
    subtitleStyles: function subtitleStyles() {
      var obj = {};
      if (!_color.isColor(this.subtitleColor)) obj.color = _color.getColor(this.subtitleColor);
      return obj;
    },
    subtitleClasses: function subtitleClasses() {
      var str = ""; // add content color

      if (_color.isColor(this.subtitleColor)) {
        str += " text-".concat(this.subtitleColor);
      }

      return str.trim();
    }
  },
  methods: {
    toggleContent: function toggleContent() {
      var _this = this;

      this.$refs.content.style.overflow = "hidden";
      var scrollHeight = this.$refs.content.scrollHeight;

      if (this.maxHeight == "1.5rem") {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this.maxHeight = "none";
          _this.$refs.content.style.overflow = null;
        }, 300);
      } else {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this.maxHeight = "1.5rem";
          _this.$refs.content.style.overflow = null;
        }, 50);
      }

      this.isContentCollapsed = !this.isContentCollapsed;
      this.$emit("toggleCollapse", this.isContentCollapsed);
    },
    refreshcard: function refreshcard() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      });
      this.tempHidden = true;
      this.$emit("refresh", this);
    },
    removeRefreshAnimation: function removeRefreshAnimation() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
      setTimeout(function () {
        _this2.$vs.loading.close(_this2.$refs.content);

        _this2.tempHidden = false;
      }, time);
    },
    removeCard: function removeCard() {
      var _this3 = this;

      var scrollHeight = this.$refs.card.scrollHeight;
      this.cardMaxHeight = "".concat(scrollHeight, "px");
      this.$el.style.overflow = "hidden";
      setTimeout(function () {
        _this3.cardMaxHeight = "0px";
      }, 50);
      this.$emit("remove");
    },
    toggleCode: function toggleCode() {
      var _this4 = this;

      this.tempHidden = true;
      this.showCode = !this.showCode;
      var scrollHeight = this.$refs.codeContainer.scrollHeight;

      if (this.codeContainerMaxHeight == "0px") {
        this.codeContainerMaxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this4.codeContainerMaxHeight = "none";
          _this4.tempHidden = false;
        }, 300);
      } else {
        this.codeContainerMaxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this4.codeContainerMaxHeight = "0px";
          _this4.tempHidden = false;
        }, 150);
      }
    }
  },
  components: {
    Prism: Prism
  }
};